module.exports = __webpack_public_path__ + "img/logos.3dfeee24.png";